<template>
  <svg
    width="26"
    height="19"
    viewBox="0 0 26 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect
      x="4.75"
      y="1.1875"
      width="14.25"
      height="16.625"
      rx="2"
      fill="#2FB776" />
    <path
      d="M4.75 13.6562H19V15.8125C19 16.9171 18.1046 17.8125 17 17.8125H6.75C5.64543 17.8125 4.75 16.9171 4.75 15.8125V13.6562Z"
      fill="url(#paint0_linear_6387_3065)" />
    <rect x="11.875" y="9.5" width="7.125" height="4.15625" fill="#229C5B" />
    <rect
      x="11.875"
      y="5.34375"
      width="7.125"
      height="4.15625"
      fill="#27AE68" />
    <path
      d="M4.75 3.1875C4.75 2.08293 5.64543 1.1875 6.75 1.1875H11.875V5.34375H4.75V3.1875Z"
      fill="#1D854F" />
    <rect x="4.75" y="5.34375" width="7.125" height="4.15625" fill="#197B43" />
    <rect x="4.75" y="9.5" width="7.125" height="4.15625" fill="#1B5B38" />
    <path
      d="M4.75 8.34375C4.75 6.6869 6.09315 5.34375 7.75 5.34375H8.875C10.5319 5.34375 11.875 6.6869 11.875 8.34375V13.0312C11.875 14.6881 10.5319 16.0312 8.875 16.0312H4.75V8.34375Z"
      fill="black"
      fill-opacity="0.3" />
    <rect
      y="4.15625"
      width="10.6875"
      height="10.6875"
      rx="2"
      fill="url(#paint1_linear_6387_3065)" />
    <path
      d="M7.71875 12.4687L6.04564 9.44062L7.6453 6.53125H6.33945L5.35191 8.38884L4.38069 6.53125H3.03404L4.64186 9.44062L2.96875 12.4687H4.27459L5.32743 10.5009L6.3721 12.4687H7.71875Z"
      fill="white" />
    <g clip-path="url(#clip0_6387_3065)">
      <path
        d="M11.75 1C11.0969 1 10.5625 1.50625 10.5625 2.125V17.875C10.5625 18.4938 11.0969 19 11.75 19H23.625C24.2781 19 24.8125 18.4938 24.8125 17.875V5.5L20.0625 1H11.75Z"
        fill="#E2E5E7" />
      <path
        d="M21.25 5.5H24.8125L20.0625 1V4.375C20.0625 4.99375 20.5969 5.5 21.25 5.5Z"
        fill="#B0B7BD" />
      <path d="M24.8125 8.875L21.25 5.5H24.8125V8.875Z" fill="#CAD1D8" />
      <path
        d="M26.25 13.1875C26.25 13.4969 25.9828 13.75 25.6562 13.75H12.5938C12.2672 13.75 12 13.4969 12 13.1875V7.5625C12 7.25312 12.2672 7 12.5938 7H25.6562C25.9828 7 26.25 7.25312 26.25 7.5625V13.1875Z"
        fill="#F15642" />
      <path
        d="M14.5879 9.22017C14.5879 9.07167 14.7114 8.90967 14.9103 8.90967H16.007C16.6245 8.90967 17.1802 9.30117 17.1802 10.0515C17.1802 10.7625 16.6245 11.1585 16.007 11.1585H15.2143V11.7525C15.2143 11.9505 15.0813 12.0625 14.9103 12.0625C14.7535 12.0625 14.5879 11.9505 14.5879 11.7525V9.22017ZM15.2143 9.47611V10.5966H16.007C16.3252 10.5966 16.577 10.3305 16.577 10.0515C16.577 9.7371 16.3252 9.47611 16.007 9.47611H15.2143Z"
        fill="white" />
      <path
        d="M18.111 12.0625C17.9542 12.0625 17.7832 11.9815 17.7832 11.7841V9.2292C17.7832 9.06776 17.9542 8.9502 18.111 8.9502H19.1981C21.3677 8.9502 21.3202 12.0625 19.2409 12.0625H18.111ZM18.4102 9.4992V11.5141H19.1981C20.48 11.5141 20.537 9.4992 19.1981 9.4992H18.4102Z"
        fill="white" />
      <path
        d="M22.0879 9.53515V10.2501H23.2985C23.4695 10.2501 23.6405 10.4121 23.6405 10.569C23.6405 10.7175 23.4695 10.839 23.2985 10.839H22.0879V11.7835C22.0879 11.941 21.9697 12.0619 21.8035 12.0619C21.5945 12.0619 21.4668 11.941 21.4668 11.7835V9.22859C21.4668 9.06715 21.595 8.94958 21.8035 8.94958H23.4701C23.6791 8.94958 23.8026 9.06715 23.8026 9.22859C23.8026 9.37259 23.6791 9.53459 23.4701 9.53459H22.0879V9.53515Z"
        fill="white" />
      <path
        d="M25.4 13.5H12L12.5 14H25.4C25.73 14 26 13.775 26 13.5V13C26 13.275 25.73 13.5 25.4 13.5Z"
        fill="#CAD1D8" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_6387_3065"
        x1="4.75"
        y1="15.7344"
        x2="19"
        y2="15.7344"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#163C27" />
        <stop offset="1" stop-color="#2A6043" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6387_3065"
        x1="0"
        y1="9.5"
        x2="10.6875"
        y2="9.5"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#185A30" />
        <stop offset="1" stop-color="#176F3D" />
      </linearGradient>
      <clipPath id="clip0_6387_3065">
        <rect width="19" height="18" fill="white" transform="translate(7 1)" />
      </clipPath>
    </defs>
  </svg>
</template>
